import { makeHTTPProvider } from 'shared/infra/providers';

export async function fetchPromocoes() {
  return makeHTTPProvider()
    .get('/promotions')
    .then(data => {
      return data
        .sort((a, b) => a.id - b.id)
        .reduce((final, curr) => {
          const previous = final.findIndex(a => a.tipo === curr.tipo);
          if (previous >= 0 && final[previous].id < curr.id) {
            final.splice(previous, 1);
          }
          return [...final, curr];
        }, []);
    });
}
